import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-password-reset-finish',
  templateUrl: './password-reset-finish.component.html',
  styleUrls: ['./password-reset-finish.component.scss']
})
export class PasswordResetFinishComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
